// Vuex holiday module mutations types

export const FILL_LIST = 'FILL_LIST';
